import {useState, useCallback, useContext, createContext} from 'react';

export const CartDrawerContext = createContext({
  isOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {},
});
export function useCartDrawer() {
  const context = useContext(CartDrawerContext);

  if (!context) {
    throw new Error('No cart context found');
  }

  return context;
}

export default function CartDrawerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {isOpen, openDrawer, closeDrawer};

  return (
    <CartDrawerContext.Provider value={value}>
      {children}
    </CartDrawerContext.Provider>
  );
}
